import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { Button } from 'core-components/library/button'
import { selectAppId } from 'core-components/sitebuilder/store/selectors/selectAppId'
import { LayoutLogin as CoreLayoutLogin } from 'src/core/layout/Login'

import styles from './Login.module.scss'

export const LayoutLogin = () => {
  const appId = useSelector(selectAppId)
  const [logo, setLogo] = useState(null)

  useEffect(() => {
    import(`./images/logo-${appId}.png`).then(({ default: appLogo }) => {
      setLogo(appLogo)
    })
  }, [appId])

  return (
    <CoreLayoutLogin
      content={({ progress, onSubmit }) => {
        return (
          <div className={styles.root}>
            <div className={styles.centering}>
              <div className={styles.content}>
                <p className={styles.welcomeText}>Welcome to</p>
                {logo ? <img className={styles.logo} src={logo} alt="HP" /> : null}
                <div className={styles.paper}>
                  <p className={styles.paper__title}>Login</p>
                  <div className={styles.form}>
                    <Button
                      loading={progress}
                      className={classNames(styles.submit)}
                      onClick={onSubmit}
                      block
                    >
                      Sign in with HP ID
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}
